export default function SafetySection() {
  const safetyItems = [
    {
      icon: 'ri-shield-check-line',
      title: 'Weryfikacja sprzedawców',
      desc: 'Wszyscy sprzedawcy w Kakobuy Spreadsheet przechodzą proces weryfikacji, co minimalizuje ryzyko oszustwa i gwarantuje dostęp do zaufanych produktów.',
    },
    {
      icon: 'ri-camera-line',
      title: 'Zdjęcia QC',
      desc: 'Kakobuy oferuje zdjęcia kontroli jakości (QC) dla każdego zamówienia. Możesz sprawdzić rzeczywisty stan produktu przed wysyłką do Polski.',
    },
    {
      icon: 'ri-bank-card-line',
      title: 'Bezpieczne płatności',
      desc: 'Wszystkie transakcje są chronione nowoczesnymi systemami bezpieczeństwa. Twoje dane płatnicze są szyfrowane i nigdy nie są udostępniane sprzedawcom.',
    },
    {
      icon: 'ri-truck-line',
      title: 'Bezpieczna wysyłka',
      desc: 'Kakobuy oferuje ubezpieczenie przesyłek oraz śledzenie paczek w czasie rzeczywistym. W razie problemów z dostawą otrzymasz wsparcie i pomoc.',
    },
    {
      icon: 'ri-lock-line',
      title: 'Ochrona prywatności',
      desc: 'Twoje dane osobowe są chronione zgodnie z polityką prywatności. Kakobuy nie udostępnia Twoich informacji stronom trzecim bez Twojej zgody.',
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Wsparcie klienta',
      desc: 'Dedykowany zespół obsługi klienta Kakobuy jest dostępny, aby pomóc w razie jakichkolwiek problemów z zamówieniem lub dostawą.',
    },
  ];

  return (
    <section id="bezpieczenstwo" className="py-14 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            Czy Kakobuy Spreadsheet jest bezpieczny?
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            Poznaj wszystkie aspekty bezpieczeństwa korzystania z Kakobuy Spreadsheet i zakupów z Chin
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {safetyItems.map((item) => (
            <div key={item.title} className="flex gap-4 p-5 md:p-6 bg-background-50 rounded-xl border border-background-200 hover:border-accent-200 transition-colors duration-200">
              <div className="w-10 h-10 md:w-12 md:h-12 flex-shrink-0 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600">
                <i className={`${item.icon} text-lg md:text-xl`}></i>
              </div>
              <div>
                <h4 className="font-semibold text-foreground-900 text-sm md:text-base mb-1.5">{item.title}</h4>
                <p className="text-foreground-600 text-xs md:text-sm leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}